export default "__VITE_ASSET__df070e3b__"